module.exports = __webpack_public_path__ + "img/学术研究1.6e6aad62.jpg";